export const BANK_ACCOUNT_ERROR = 'Bank Account Error';
